module.exports = __webpack_public_path__ + "static/media/courses_carousel.c17baf7f.jpg";